import ReactMarkdown, { type Components } from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import remarkBreaks from 'remark-breaks'
import remarkGfm from 'remark-gfm'

import { CodeBlock } from '@/lib/ui-kit/components/ui/CodeBlock.component'
import { processTagsInParagraph } from '@/lib/utils/processTags'

import { DynamicLink, DynamicLinkProps } from './DynamicLink.client';
import { TextListItem } from './TextListItem.component'
import { TextStrikethrough } from './TextStrikethrough.component'
import { TextBold } from './TextStrong.component'
import { TextUnderline } from './TextUnderline.component'

interface ReactMarkdownProps {
  components?: Components
  children?: string | null
  className?: string
  parseCustomTags?: boolean
}

export const Markdown = ({
  children,
  components,
  // currently only set to true for the Academy Highlight
  parseCustomTags = false,
}: ReactMarkdownProps) => {
  const paragraphComponent = parseCustomTags
    ? processTagsInParagraph
    : undefined

  // @ts-expect-error ok boomer
  const MarkdownLink = (props) => {
    const { href, children, className, ...rest } = props;
    const textLinkClasses = "border-b-[0.08em] border-solid border-[currentColor] text-inherit transition-all duration-200 ease-in hover:border-gray-500 hover:text-gray-500";
    const combinedClassName = className ? `${textLinkClasses} ${className}` : textLinkClasses;

    const linkProps: DynamicLinkProps = {
      href: href || '',
      children,
      className: combinedClassName,
      target: '_blank',
      rel: 'noopener noreferrer',
      ...rest,
    };
    return <DynamicLink {...linkProps} />;
  };

  return (
    <ReactMarkdown
      rehypePlugins={[rehypeRaw]}
      remarkPlugins={[remarkBreaks, remarkGfm]}
      components={{
        strong: TextBold,
        u: TextUnderline,
        a: MarkdownLink,
        del: TextStrikethrough,
        code: CodeBlock,
        li: TextListItem,
        ...(parseCustomTags ? { p: paragraphComponent } : {}),
        ...components,
      }}
    >
      {children}
    </ReactMarkdown>
  )
}
